import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  addButton: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.background.light,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    }
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0),
    height: 1,
    backgroundColor: '#D8D8D880',
  },
  botaoDireta: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  cnpjButton: {
    marginLeft: theme.spacing(2),
  },
}));
